import { RestockDateRouteService } from 'common/data';
import { BaseService } from 'core/services';

class RestockDateService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new RestockDateRouteService());
	}

	createRestockDate(restockDateParams, sourceOfChange) {
		var url = this.routeService.createRestockDate(restockDateParams, sourceOfChange);
		return this.apiClient.post(url, restockDateParams);
	}

	updateRestockDate(restockDateParams, sourceOfChange) {
		var url = this.routeService.updateRestockDate(restockDateParams, sourceOfChange);
		return this.apiClient.post(url, restockDateParams);
	}
}

export default RestockDateService;



// WEBPACK FOOTER //
// ./src/common/data/services/RestockDateService.js